import React from 'react';
import Entry from '../entry';
import { Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '2. Unredact Threatening Document';
  const flag = 'DEMAND';
  const hints = [];
  const assignment = 'Someone sent a threatening letter to Elf University. What is the first word in ALL CAPS in the subject line of the letter? Please find the letter in the Quad.';
  const data = useStaticQuery(graphql`
    query {
      threatDoc: file(relativePath: { eq: "threatDoc.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      letterShot: file(relativePath: { eq: "letterShot.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      unredacted: file(relativePath: { eq: "unredacted.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)


  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
     <Text my={2}> The threatening letter is located in upper left corner of the Quad, not far from the entrance to Student Union:</Text>
     <Img fluid={data.letterShot.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '40vh' }}
             imgStyle={{ objectFit: 'contain' }}
     />

     <Text my={2}> The letter has some seemingly redacted parts: </Text>
     <Img fluid={data.threatDoc.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '60vh' }}
             imgStyle={{ objectFit: 'contain' }}
     />
     <Text my={2}> Click and drag across the PDF document to select and copy all of its text. Here is the pasted text:  </Text>
     <Img fluid={data.unredacted.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '60vh' }}
             imgStyle={{ objectFit: 'contain' }}
     />
     <Text my={2}>Now the entire subject line is visible, and its first word in all caps.</Text>
    </Entry>
  )

};
